// src/services/noteService.js
import api from "../utils/api";
const API_URL = process.env.REACT_APP_API_URL + "/notes.php";

// Get notes for a project
export const getNotesByProjectId = async (projectId) => {
  const response = await api.post(API_URL, {
    action: "getByProjectId",
    projectId,
  });
  return response.data.notes || [];
};

// Add a new note
export const addNote = async (noteData) => {
  const response = await api.post(API_URL, {
    ...noteData,
    action: "add",
  });
  return response.data;
};

// Update a note
export const updateNote = async (noteData) => {
  const response = await api.post(API_URL, {
    ...noteData,
    action: "update",
  });
  return response.data;
};

// Delete a note
export const deleteNote = async (id) => {
  const response = await api.post(API_URL, {
    id,
    action: "delete",
  });
  return response.data;
};
